import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCreateEntity } from "../create/mutation";
import { useUpdateEntity } from "../update/mutation";
import { eventBus } from "utils/eventBus";
import { EntitySchema } from "./schema";
import { fetchEntityDataforForm } from "./read";

export const useEntityForm = ({ entityId }) => {
    const navigate = useNavigate();

    const createEntityMutation = useCreateEntity();
    const updateEntityMutation = useUpdateEntity();

    const form = useForm({
        resolver: zodResolver(EntitySchema),
        defaultValues: {
            name: "",
            status: "active",
            organisation: "",
        },
    });

    const requiredFields = useMemo(
        () => getRequiredFields(EntitySchema),
        [EntitySchema]
    );

    async function handleCreate(context) {
        const values = context.values;
        const response = await createEntityMutation.mutateAsync({
            values,
        });
        navigate(`/organization/entities`);
        eventBus.emit("refresh:list", "legal_entitiesorganization-entities");
    }

    async function handleRead(id) {
        const response = await fetchEntityDataforForm({ id });
        const data = {
            ...response,
            organisation: response.organisation?.id || "",
        };
        return data;
    }

    async function handleUpdate(entityId, context) {
        const values = context.dirtyValues;
        const response = await updateEntityMutation.mutateAsync({
            entityId,
            values,
        });
        navigate(`/organization/entities`);
        eventBus.emit("refresh:list", "legal_entitiesorganization-entities");
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    };
};
